import React, {Component} from "react";
import Doc from "./DocService";
import PdfContainer from "./PdfContainer";
import ReactDOM from "react-dom";
import classes from 'classnames';

/**
 * @abstract
 */
class ExportableComponent extends Component {

    render = () => {
        const {exportOnly} = this.props;

        return (
            <div className={classes("pdf-container", exportOnly ? "export-only" : '')}>
                <div className="pdf-content" ref="report">
                    <div className="pdf-wrapper">
                        {this.renderContent()}
                    </div>
                </div>
            </div>
        );
    };

    /**
     * The component to be export.
     * @returns {React.ReactNode}
     * @abstract
     */
    renderContent = () => <h1> Your Component </h1>;

    reportRef = () => this.refs.report;
    reportNode = () => ReactDOM.findDOMNode(this.reportRef());

    /**
     * Creates
     * @param fileName
     * @param onGenerateEnd
     */
    createPdf = (fileName, onGenerateEnd = console.log) => Doc.exportPdf(this.componentToExport(), fileName, onGenerateEnd);
    createPng = (fileName, onGenerateEnd = console.log) => Doc.exportPng(this.componentToExport(), fileName, onGenerateEnd);
    componentToExport = () => this.reportNode(this.reportRef());
}

export default ExportableComponent;
